import type { Contact } from '@hunting-nature/shared-core/interfaces/contact-response.interface';
import { createAction, props } from '@ngrx/store';

import type { UserConsentItem } from '../services/consent.rest.service';
import { prefixed } from '../../../shared/utils/factory.utils';
import { UserSubscriptionResponse } from '@hunting-nature/shared-core/interfaces/user-subscription-response.interface';
import { UserCreditsResponse } from '@hunting-nature/shared-core/interfaces/user-credits-response.interface';

const menu = prefixed('[Menu]');

export const MenuActions = {
  menuEntered: createAction(menu('Menu Entered'), props<{ language: string; contactsAlreadyLoaded: boolean }>()),
  menuEnteredSucceeded: createAction(menu('Menu Entered succeeded'), props<{ consents: Array<UserConsentItem> }>()),
  menuEnteredFailed: createAction(menu('Menu Entered failed'), props<{ error: unknown }>()),

  menuEnteredStorageSucceeded: createAction(menu('Menu Entered storage succeeded'), props<{ freeSpace: number | undefined }>()),
  menuEnteredStorageFailed: createAction(menu('Menu Entered storage failed'), props<{ error: unknown }>()),

  menuEnteredContactsSucceeded: createAction(menu('Menu Entered contacts succeeded'), props<{ contacts: Array<Contact> }>()),
  menuEnteredContactsFailed: createAction(menu('Menu Entered contacts failed'), props<{ error: any }>()),

  subscriptionCardEntered: createAction(menu('Fetch Subscription Details')),
  subscriptionCardEnterSucceeded: createAction(
    menu('Fetch Subscription Details Success'),
    props<{ subscriptionDetails: UserSubscriptionResponse; creditDetails: UserCreditsResponse }>()
  ),
  subscriptionCardEnterFailed: createAction(menu('Fetch Subscription Details Failure'), props<{ error: unknown }>()),

  subscriptionsAndPlansPageEntered: createAction(menu('Enter Subscriptions and Plans')),
  subscriptionsAndPlansPageEnteredSucceeded: createAction(
    menu('Enter Subscriptions and Plans succeeded'),
    props<{ subscriptionDetails: UserSubscriptionResponse; creditDetails: UserCreditsResponse }>()
  ),
  subscriptionsAndPlansPageEnteredFailed: createAction(menu('Enter Subscriptions and Plans failed'), props<{ error: any }>()),

  openAppSettings: createAction(menu('Open App Settings')),
  openAppSettingsSucceeded: createAction(menu('Open App Settings succeeded')),
  openAppSettingsFailed: createAction(menu('Open App Settings failed'), props<{ error: any }>()),

  openFaq: createAction(menu('Open FAQ')),
  openContactSupport: createAction(menu('Open Contact Support')),

  upgradePlan: createAction(menu('Upgrade Plan')),
  openAddCreditsSite: createAction(menu('Add Credits')),
  openBilling: createAction(menu('Open Billing')),
  openInvoices: createAction(menu('Open Invoices')),
};
